import { apiCall } from './gqlClient';

const GETHOLIDAYS_QUERY = `
  query getHolidays {
    getHolidays
    {
      id
			resourceId
			providerId
			startTime
			endTime
			description
			isWholeDay
      ...fragments
    }
  }`;

export const getHolidaysApiCall = async (fragments = null) => apiCall({ query: GETHOLIDAYS_QUERY, variables: {}, fragments });

const GETRESOURCEHOLIDAYS_QUERY = `
  query getResourceHolidays($resourceId: Int!) {
    getResourceHolidays(resourceId: $resourceId)
    {
      id
			resourceId
			providerId
			startTime
			endTime
			description
			isWholeDay
      ...fragments
    }
  }`;

export const getResourceHolidaysApiCall = async ({resourceId}, fragments = null) => apiCall({ query: GETRESOURCEHOLIDAYS_QUERY, variables: {resourceId}, fragments });

const REMOVERESOURCEFROMHOLIDAY_QUERY = `
  mutation removeResourceFromHoliday($holidayId: Int!, $resourceId: Int!) {
    removeResourceFromHoliday(holidayId: $holidayId, resourceId: $resourceId)
  }`;

export const removeResourceFromHolidayApiCall = async ({holidayId, resourceId}, ) => apiCall({ query: REMOVERESOURCEFROMHOLIDAY_QUERY, variables: {holidayId, resourceId}});

const REMOVEHOLIDAY_QUERY = `
  mutation removeHoliday($holidayId: Int!) {
    removeHoliday(holidayId: $holidayId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const removeHolidayApiCall = async ({holidayId}, fragments = null) => apiCall({ query: REMOVEHOLIDAY_QUERY, variables: {holidayId}, fragments });

const SAVEHOLIDAY_QUERY = `
  mutation saveHoliday($startTime: DateTime!, $endTime: DateTime!, $description: String!, $resources: [Int]) {
    saveHoliday(startTime: $startTime, endTime: $endTime, description: $description, resources: $resources)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveHolidayApiCall = async ({startTime, endTime, description, resources}, fragments = null) => apiCall({ query: SAVEHOLIDAY_QUERY, variables: {startTime, endTime, description, resources}, fragments });

const SAVEHOLIDAYREPEAT_QUERY = `
  mutation saveHolidayRepeat($startTime: DateTime!, $endTime: DateTime!, $description: String!, $resources: [Int]) {
    saveHolidayRepeat(startTime: $startTime, endTime: $endTime, description: $description, resources: $resources)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveHolidayRepeatApiCall = async ({startTime, endTime, description, resources}, fragments = null) => apiCall({ query: SAVEHOLIDAYREPEAT_QUERY, variables: {startTime, endTime, description, resources}, fragments });

const EDITHOLIDAY_QUERY = `
  mutation editHoliday($id: Int!, $startTime: DateTime!, $endTime: DateTime!, $description: String!, $resources: [Int], $modifyResources: Boolean) {
    editHoliday(id: $id, startTime: $startTime, endTime: $endTime, description: $description, resources: $resources, modifyResources: $modifyResources)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const editHolidayApiCall = async ({id, startTime, endTime, description, resources, modifyResources}, fragments = null) => apiCall({ query: EDITHOLIDAY_QUERY, variables: {id, startTime, endTime, description, resources, modifyResources}, fragments });
